<!-- 新建检查计划页面 -->
<template>
  <div class="create-check-plan">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-left">
        <el-button type="text" icon="el-icon-arrow-left" @click="goBack" class="back-btn">
          {{ pageMode === "edit" ? "编辑安全检查计划" : "新建安全检查计划" }}
        </el-button>
      </div>
    </div>

    <!-- 表单内容 -->
    <div class="form-container">
      <el-form ref="checkPlanForm" :model="form" :rules="rules" label-width="120px" class="check-plan-form">
        <!-- 计划核心信息卡片 -->
        <div class="form-card">
          <div class="card-header">
            <span class="card-title">计划核心信息</span>
          </div>
          <div class="card-content">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="计划名称" prop="planName" required>
                  <el-input v-model="form.planName" placeholder="请输入计划名称,如:2024年Q1消防专项检查" maxlength="100" show-word-limit />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="检查类型" prop="checkType" required>
                  <el-select v-model="form.checkType" placeholder="请选择检查类型" style="width: 100%" @change="handleCheckTypeChange">
                    <el-option v-for="item in checkTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="责任部门" prop="responsibleDeptId" required>
                  <!-- <el-cascader v-model="form.responsibleDeptId" :options="departmentTreeData" :props="deptTreeProps" placeholder="请选择责任部门" style="width: 100%" clearable :show-all-levels="false" @change="handleDepartmentChange" /> -->
                  <el-select v-model="form.responsibleDeptId" placeholder="请选择负责部门" style="width: 100%" multiple collapse-tags @change="handleDepartmentChange">
                    <el-option v-for="item in departmentTreeData" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="负责人" prop="responsiblePersonId" required>
                  <el-select v-model="form.responsiblePersonId" placeholder="请选择负责人" style="width: 100%" multiple @change="handlePersonChange" @click="showPersonDialog = true">
                    <el-option v-for="item in personOptions" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="验收人员" prop="acceptPerson" required>
                  <el-select v-model="form.acceptPerson" placeholder="请选择验收人员" style="width: 100%" multiple @change="handleAcceptPersonChange" @click="showPersonDialog = true">
                    <el-option v-for="item in personOptions" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item label="计划描述">
                  <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入计划描述..." maxlength="500" show-word-limit />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 时间与周期设置部分 -->
            <div class="section-divider"></div>
            <div class="section-title">时间与周期设置</div>

            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="计划周期" prop="planCycle" required>
                  <el-radio-group v-model="form.planCycle" @change="handlePlanCycleChange">
                    <el-radio :label="0">一次性计划</el-radio>
                    <el-radio :label="1">周期性计划</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="开始日期" prop="planStartDate" required>
                  <el-date-picker v-model="form.planStartDate" type="date" placeholder="选择开始日期" style="width: 100%" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="handleStartDateChange" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="结束日期" prop="planEndDate">
                  <el-date-picker v-model="form.planEndDate" type="date" placeholder="选择结束日期" style="width: 100%" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :disabled="!form.planStartDate" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20" v-if="form.planCycle === 1">
              <el-col :span="12">
                <el-form-item label="执行频率" prop="checkFrequency" required>
                  <el-select v-model="form.checkFrequency" placeholder="请选择执行频率" style="width: 100%" @change="handleCheckFrequencyChange">
                    <el-option v-for="item in checkFrequencyOptions" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="频率详情" prop="executionDetail" required>
                  <el-select v-model="form.executionDetail" placeholder="请选择频率详情" style="width: 100%" :disabled="
                      form.checkFrequency === null ||
                      form.checkFrequency === undefined
                    " :multiple="
                      form.checkFrequency === 1 || form.checkFrequency === 2
                    " >
                    <el-option v-for="item in frequencyDetailOptions" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 检查范围与标准部分 -->
            <div class="section-divider"></div>
            <div class="section-title">检查范围与标准</div>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="检查区域" prop="list" required>
                  <el-select v-model="form.list" placeholder="请选择检查区域" style="width: 100%" multiple @click="showAreaDialog = true">
                    <el-option v-for="item in areaOptions" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="关联检查表" prop="checkListId" required>
                  <el-select v-model="form.checkListId" placeholder="请选择检查表" style="width: 100%" :disabled="!form.checkType && form.checkType !== 0" :loading="formOptionsLoading" @change="handleCheckListChange">
                    <el-option v-for="item in formOptions" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <el-button type="text" icon="el-icon-view" @click="previewInspectionItems">
                    预览检查项内容
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="form-actions">
          <el-button @click="handleReset">重置</el-button>
          <el-button type="primary" @click="handleSubmit" :loading="submitting" >
            {{ pageMode === "edit" ? "保存修改" : "立即创建" }}
          </el-button>
        </div>
      </el-form>
    </div>
    <!-- 检查项预览对话框 -->
    <el-dialog title="检查项内容预览" :visible.sync="showPreviewDialog" width="800px" :close-on-click-modal="true" :modal="true" :append-to-body="true" :z-index="3000">
      <div class="inspection-preview">
        <el-table :data="previewData" max-height="400">
          <el-table-column prop="itemName" label="检查项目" />
          <el-table-column prop="checkListStandard" label="检查标准" />
          <el-table-column prop="isRequired" label="是否是必检项" width="100" />
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showPreviewDialog = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addCheckPlan,
  updateCheckPlan,
  getUserList,
  getDeptTree,
  getCheckListByType,
  getCheckListPreview,
  getCheckTypeOptions,
  getAreaOptions,
} from "./api";

export default {
  name: "CreateCheckPlan",
  data () {
    return {
      // 页面模式：add-新增，edit-编辑
      pageMode: "add",
      // 编辑模式下的计划ID
      editId: null,
      // 表单数据 - 根据实体类字段调整
      form: {
        planName: "", // 计划名称
        checkType: null, // 检查类型（1-8）
        responsibleDeptId: [], // 责任部门ID
        responsibleDeptName: "", // 责任部门名称
        responsiblePersonId: [], // 负责人ID数组
        acceptPerson: [], // 验收人员
        responsiblePersonName: "", // 负责人姓名
        checkFrequency: null, // 执行频率（0-2）
        planCycle: null, // 计划周期（0-1）
        executionDetail: [], // 频率详情（当每周/每月为多选）
        planStartDate: "", // 开始日期
        planEndDate: "", // 结束日期
        checkListId: null, // 关联检查表ID
        checkListName: "", // 关联检查表名称
        remark: "", // 计划描述
        list: [], // 检查区域列表
      },

      // 表单验证规则 - 根据实体类字段调整
      rules: {
        planName: [
          { required: true, message: "请输入计划名称", trigger: "blur" },
          {
            min: 2,
            max: 100,
            message: "计划名称长度在2到100个字符",
            trigger: "blur",
          },
        ],
        planStartDate: [
          { required: true, message: "请选择开始日期", trigger: "change" },
        ],
        checkType: [
          { required: true, message: "请选择检查类型", trigger: "change" },
        ],
        responsibleDeptId: [
          { required: true, message: "请选择责任部门", trigger: "change" },
        ],
        responsiblePersonId: [
          { required: true, message: "请选择负责人", trigger: "change" },
        ],
        acceptPerson: [
          { required: true, message: "请选择验收人员", trigger: "change" },
        ],
        checkFrequency: [
          { required: true, message: "请选择执行频率", trigger: "change" },
        ],
        planCycle: [
          { required: true, message: "请选择计划周期", trigger: "change" },
        ],
        list: [
          { required: true, message: "请选择检查区域", trigger: "change" },
        ],
        checkListId: [
          { required: true, message: "请选择检查表", trigger: "change" },
        ],
      },

      // 检查类型选项 - 从接口获取
      checkTypeOptions: [],
      // 检查类型原始数据 - 用于匹配
      checkTypeRawData: [],

      // 执行频率选项
      checkFrequencyOptions: [
        { label: "每日", value: 0 },
        { label: "每周", value: 1 },
        { label: "每月", value: 2 },
      ],

      // 计划周期选项
      planCycleOptions: [
        { label: "一次性", value: 0 },
        { label: "周期性", value: 1 },
      ],

      // 部门树形数据
      departmentTreeData: [],

      // 级联选择器配置
      deptTreeProps: {
        children: "children",
        label: "deptName",
        value: "id",
        emitPath: true, // 返回完整路径，支持编辑模式回显
      },

      // 负责人选项
      personOptions: [],
      personSearchKeyword: "",
      personTableData: [],
      // 区域选项 - 从接口获取
      areaOptions: [],
      areaTreeData: [],

      // 检查表选项（根据检查类型动态获取）
      formOptions: [],
      formOptionsLoading: false,

      // 频率详情选项
      frequencyDetailOptions: [],

      // 对话框状态
      showPersonDialog: false,
      showAreaDialog: false,
      showPreviewDialog: false,

      // 树形组件配置
      treeProps: {
        children: "children",
        label: "label",
      },

      // 选中的项目
      checkedAreas: [],
      selectedPersons: [],

      // 搜索关键词
      areaSearchKeyword: "",

      // 预览数据
      previewData: [],

      // 提交状态
      submitting: false,
    };
  },

  computed: {
    // 过滤后的负责人选项
    filteredPersonOptions () {
      if (!this.personSearchKeyword) {
        return this.personTableData;
      }
      return this.personTableData.filter(
        (item) =>
          item.name.includes(this.personSearchKeyword) ||
          item.department.includes(this.personSearchKeyword) ||
          item.position.includes(this.personSearchKeyword)
      );
    },
  },

  async mounted () {
    this.initPageMode();
    // 如果是编辑模式，先初始化基础数据，再填充表单
    if (this.pageMode === "edit") {
      // 先解析编辑数据，设置基本字段
      const query = this.$route.query;
      if (query.data) {
        try {
          const responseData = JSON.parse(query.data);
          const rowData = responseData.data || responseData;
          // 先设置基本字段，包括部门ID
          this.setBasicEditData(rowData);
        } catch (error) {
          console.error("解析编辑数据失败:", error);
        }
      }
      // 然后加载基础数据（包括部门树和检查类型）
      await this.initData();
      // 基础数据加载完成后，填充完整的表单数据
      if (query.data) {
        try {
          const responseData = JSON.parse(query.data);
          const rowData = responseData.data || responseData;
          this.fillFormFromEditData(rowData);
        } catch (error) {
          console.error("解析编辑数据失败:", error);
        }
      }
    } else {
      await this.initData();
    }
  },

  methods: {
    // 初始化页面模式
    initPageMode () {
      const query = this.$route.query;
      if (query.mode === "edit" && query.data) {
        this.pageMode = "edit";
        this.editId = query.id;
        // 先填充基本字段，其他字段在initData完成后填充
        try {
          const responseData = JSON.parse(query.data);
          const rowData = responseData.data || responseData;
          this.form.planName = rowData.planName || "";
          this.form.checkType = rowData.checkType || null;
          this.form.responsibleDeptName = rowData.responsibleDeptName || "";
          this.form.remark = rowData.remark || "";
          this.$set(this.form, 'planCycle', rowData.planCycle)
          this.form.checkFrequency = rowData.checkFrequency === 0 ? rowData.checkFrequency : (rowData.checkFrequency || null);
          this.form.checkListId =
            rowData.checkListId !== undefined && rowData.checkListId !== null
              ? String(rowData.checkListId)
              : null;
          this.form.checkListName = rowData.checkListName || "";

          // 处理责任部门 - 先设置ID，路径在部门数据加载后设置
          this.form.responsibleDeptId = this.normalizeDeptIds(rowData);
        } catch (error) {
          console.error("解析编辑数据失败:", error);
        }
      } else {
        this.pageMode = "add";
      }
    },

    // 设置编辑模式的基本数据
    setBasicEditData (rowData) {
      // 设置基本字段
      this.form.planName = rowData.planName || "";
      // 检查类型需要特殊处理，确保类型匹配
      if (rowData.checkType !== null && rowData.checkType !== undefined) {
        // 如果checkType是数字，需要转换为对应的typeCode
        this.form.checkType = String(rowData.checkType);
      } else {
        this.form.checkType = null;
      }
      this.form.responsibleDeptName = rowData.responsibleDeptName || "";
      this.form.remark = rowData.remark || "";
      this.$set(this.form, 'planCycle', rowData.planCycle)
      this.form.checkFrequency = rowData.checkFrequency === 0 ? rowData.checkFrequency : (rowData.checkFrequency || null);
      this.form.checkListId =
        rowData.checkListId !== undefined && rowData.checkListId !== null
          ? String(rowData.checkListId)
          : null;
      this.form.checkListName = rowData.checkListName || "";
      this.form.planStartDate = rowData.planStartDate || "";
      this.form.planEndDate = rowData.planEndDate || "";

      // 设置部门ID（稍后会在部门数据加载完成后设置路径）
      this.form.responsibleDeptId = this.normalizeDeptIds(rowData);
    },

    // 从编辑数据填充表单
    fillFormFromEditData (rowData) {
      this.form.responsibleDeptId = this.normalizeDeptIds(rowData);

      // 更新检查表选项，确保编辑模式下能正确显示
      this.$nextTick(() => {
        if (this.updateCheckListOptions) this.updateCheckListOptions();
      });

      // 处理负责人数据（按照检查区域的方式回显）

      if (rowData.responsiblePersonId) {
        if (typeof rowData.responsiblePersonId === "string") {
          this.form.responsiblePersonId = rowData.responsiblePersonId
            .split(",")
            .map((id) => parseInt(id))
            .filter((id) => !Number.isNaN(id));
        } else if (Array.isArray(rowData.responsiblePersonId)) {
          this.form.responsiblePersonId = rowData.responsiblePersonId;
        } else if (typeof rowData.responsiblePersonId === "number") {
          // 处理数字类型的负责人ID
          this.form.responsiblePersonId = [rowData.responsiblePersonId];
        }
      }
      if (rowData.acceptPerson) {
        if (typeof rowData.acceptPerson === "string") {
          this.form.acceptPerson = rowData.acceptPerson
            .split(",")
        } else if (Array.isArray(rowData.acceptPerson)) {
          this.form.acceptPerson = rowData.acceptPerson;
        } else if (typeof rowData.acceptPerson === "number") {
          // 处理数字类型的负责人ID
          this.form.acceptPerson = [rowData.acceptPerson];
        }
      }
      this.form.responsiblePersonName = rowData.responsiblePersonName || "";

      // 更新负责人选项，确保编辑模式下能正确显示（按照检查区域的方式）
      this.$nextTick(() => {
        this.updatePersonOptions();
      });

      // 处理频率详情（按照检查区域的方式回显）
      if (rowData.executionDetail) {
        // 先设置频率，然后再设置详情
        if (
          rowData.checkFrequency !== null &&
          rowData.checkFrequency !== undefined
        ) {
          // 先触发频率变化，生成对应的选项
          this.handleCheckFrequencyChange(rowData.checkFrequency);
        }

        try {
          // 尝试JSON解析
          const details = JSON.parse(rowData.executionDetail);
          if (Array.isArray(details)) {
            this.form.executionDetail = details;
          } else {
            this.form.executionDetail = details;
          }
        } catch (e) {
          // 如果不是JSON，直接使用字符串值
          if (rowData.checkFrequency === 0) {
            // 每日频率是单选
            this.form.executionDetail = rowData.executionDetail;
          } else {
            // 每周/每月频率是多选，需要转成数组
            this.form.executionDetail = rowData.executionDetail
              .split(",")
              .filter((v) => v);
          }
        }
      }

      // 处理检查区域数据（优先使用 areaCode/areaName，其次兼容旧字段）
      if (rowData.areaCode) {
        // 保持字符串类型，不进行parseInt转换
        const ids = String(rowData.areaCode)
          .split(",")
          .map((id) => id.trim()) // 只去除空格，保持字符串类型
          .filter((id) => id); // 过滤空字符串
        this.form.list = ids;
        this.checkedAreas = ids;

        // 编辑模式下不自动添加缺失的选项
      } else if (rowData.list && Array.isArray(rowData.list)) {
        // 如果后端返回了区域数据对象数组，提取区域ID
        const ids = rowData.list
          .map((item) => String(item.areaId || item.id)) // 确保转换为字符串
          .filter((id) => id !== undefined && id !== null);
        this.form.list = ids;
        this.checkedAreas = ids;

        // 编辑模式下不自动添加缺失的选项
      }

      // 编辑模式下不再自动添加缺失的选项
    },

    // 更新负责人选项，确保编辑模式下能正确显示（按照检查区域的方式）
    updatePersonOptions () {
      if (
        this.form.responsiblePersonId &&
        this.form.responsiblePersonId.length > 0 &&
        this.form.responsiblePersonName
      ) {
        // 按照检查区域的方式处理：根据ID和Name同步构建选项
        const personIds = this.form.responsiblePersonId;
        const personNames = this.form.responsiblePersonName.split(",");

        // 如果负责人ID存在但选项中没有对应的选项，需要添加
        const existingIds = this.personOptions.map((option) => option.value);
        const missingIds = personIds.filter((id) => !existingIds.includes(id));

        if (missingIds.length > 0) {
          // 为缺失的ID创建选项，使用实际的负责人姓名（一一对应）
          const missingOptions = missingIds.map((id, index) => {
            const personIndex = personIds.indexOf(id);
            const personName = personNames[personIndex] || `用户${id}`;
            return {
              label: personName,
              value: id,
            };
          });
          this.personOptions = [...this.personOptions, ...missingOptions];
        }
      }
    },


    // 更新检查区域选项，确保编辑模式下能正确显示
    updateAreaOptionsForEdit (areaIds, areaNames) {
      if (areaIds && areaIds.length > 0 && areaNames) {
        const names = areaNames.split(",");

        // 检查是否需要添加缺失的选项，确保字符串类型比较
        const existingIds = this.areaOptions.map((option) =>
          String(option.value)
        );
        const missingIds = areaIds.filter(
          (id) => !existingIds.includes(String(id))
        );

        if (missingIds.length > 0) {
          // 为缺失的ID创建选项，使用实际的区域名称（一一对应）
          const missingOptions = missingIds.map((id, index) => {
            const areaIndex = areaIds.indexOf(id);
            const areaName = names[areaIndex] || `区域${id}`;
            return {
              label: areaName,
              value: String(id), // 确保value是字符串类型
            };
          });
          this.areaOptions = [...this.areaOptions, ...missingOptions];
        }

        // 去重处理：确保没有重复的选项
        const uniqueOptions = [];
        const seenValues = new Set();

        this.areaOptions.forEach((option) => {
          const valueStr = String(option.value);
          if (!seenValues.has(valueStr)) {
            seenValues.add(valueStr);
            uniqueOptions.push(option);
          }
        });

        this.areaOptions = uniqueOptions;
      }
    },

    // 更新频率详情选项，确保编辑模式下能正确显示
    updateFrequencyDetailOptions () {
      if (this.form.executionDetail && this.form.executionDetail.length > 0) {
        // 根据当前执行频率生成对应的频率详情选项
        this.handleCheckFrequencyChange(this.form.checkFrequency);
      }
    },

    // 返回上一页
    goBack () {
      this.$router.go(-1);
    },

    // 初始化数据
    async initData () {
      // 从接口获取部门树形数据
      await this.loadDeptTree();

      // 从接口获取用户列表
      await this.loadUserList();

      // 从接口获取检查类型选项
      await this.loadCheckTypeOptions();

      // 从接口获取检查区域选项
      await this.loadAreaOptions();

      // 如果是编辑模式且有检查类型，需要加载对应的检查表
      if (this.pageMode === "edit" && this.form.checkType !== null) {
        await this.handleCheckTypeChange(this.form.checkType);
      }
    },

    // 加载部门树形数据
    async loadDeptTree () {
      try {
        const response = await getDeptTree();
        if (response && response.data) {
          // this.departmentTreeData = response.data;
          this.departmentTreeData = response.data.map((person) => ({
            label: person.deptName,
            value: person.id,
          }));

          // 如果是编辑模式且有部门ID，设置部门路径
          if (!Array.isArray(this.form.responsibleDeptId)) {
            const deptId = this.form.responsibleDeptId;

            // 如果当前是字符串ID，需要转换为路径
            if (typeof deptId === "string" || typeof deptId === "number") {
              const deptPath = this.findDeptPathById(
                this.departmentTreeData,
                String(deptId)
              );
              if (deptPath) {
                this.form.responsibleDeptId = deptPath;
              } else {
                console.warn("未找到部门路径，部门ID:", deptId);
                // 如果找不到路径，保持原始ID，但确保是字符串格式
                this.form.responsibleDeptId = String(deptId);
              }
            }
          }
        } else {
          console.warn("部门树形数据为空");
        }
      } catch (error) {
        console.error("获取部门树形数据失败:", error);
        this.$message.error("获取部门树形数据失败");
      }
    },

    // 加载用户列表
    async loadUserList () {
      try {
        const response = await getUserList();
        if (response && response.data && response.data.length > 0) {
          // 更新负责人表格数据
          this.personTableData = response.data.map((user) => ({
            id: user.id,
            name: user.name,
            department: user.deptName || user.department || "未知部门",
            position: user.postName || user.position || "未知职位",
          }));

          // 更新负责人选项
          this.personOptions = this.personTableData.map((person) => ({
            label: person.name,
            value: person.id,
          }));
        }
      } catch (error) {
        console.error("获取用户列表失败:", error);
        this.$message.error("获取用户列表失败");
        // 如果接口失败，使用默认数据
        this.personOptions = this.personTableData.map((person) => ({
          label: person.name,
          value: person.id,
        }));
      }
    },

    // 加载检查类型选项
    async loadCheckTypeOptions () {
      try {
        const response = await getCheckTypeOptions(1);

        // 根据实际返回的数据格式处理
        let data = [];
        if (response && response.code === 200) {
          // 如果返回格式是 { code: 200, data: [...] }
          data = response.data || [];
        } else if (Array.isArray(response)) {
          // 如果直接返回数组
          data = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          // 如果返回格式是 { data: [...] }
          data = response.data;
        }

        console.log(data)

        if (data && data.length > 0) {
          // 保存原始数据用于匹配
          this.checkTypeRawData = data;
          this.checkTypeOptions = data.map((item) => ({
            label: item.typeName,
            value: item.typeCode,
            safeyType: item.safeyType, // 保存safeyType用于匹配
          }));

          // 如果是编辑模式，需要处理检查类型的回显
          if (this.pageMode === "edit" && this.form.checkType) {
            this.handleEditModeCheckType();
          }
        } else {
          console.warn("检查类型数据为空:", response);
          this.checkTypeOptions = [];
        }
      } catch (error) {
        console.error("获取检查类型选项异常:", error);
        this.$message.error("获取检查类型选项异常");
        this.checkTypeOptions = [];
      }
    },

    // 加载检查区域选项
    async loadAreaOptions () {
      try {
        const response = await getAreaOptions(2);

        // 根据实际返回的数据格式处理
        let data = [];
        if (response && response.code === 200) {
          // 如果返回格式是 { code: 200, data: [...] }
          data = response.data || [];
        } else if (Array.isArray(response)) {
          // 如果直接返回数组
          data = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          // 如果返回格式是 { data: [...] }
          data = response.data;
        }

        if (data && data.length > 0) {
          // 构建树形结构数据
          this.areaTreeData = data.map((item) => ({
            value: item.typeCode,
            label: item.typeName,
            children: [], // 如果有子级区域，可以在这里处理
          }));

          // 构建平级选项数据
          this.areaOptions = data.map((item) => ({
            label: item.typeName,
            value: item.typeCode,
          }));
        } else {
          console.warn("检查区域数据为空:", response);
          this.areaTreeData = [];
          this.areaOptions = [];
        }
      } catch (error) {
        console.error("获取检查区域选项异常:", error);
        this.$message.error("获取检查区域选项异常");
        this.areaTreeData = [];
        this.areaOptions = [];
      }
    },

    // 处理编辑模式下的检查类型回显
    handleEditModeCheckType () {
      // 如果当前checkType是数字，需要找到对应的typeCode
      if (this.form.checkType) {
        // 尝试将数字字符串转换为数字进行匹配
        const numericValue = parseInt(this.form.checkType);
        if (!isNaN(numericValue)) {
          // 查找对应的typeCode
          const matchedOption = this.checkTypeOptions.find((option) => {
            return option.safeyType === numericValue;
          });

          if (matchedOption) {
            this.form.checkType = matchedOption.value; // 使用typeCode
          } else {
            console.warn(
              "未找到匹配的检查类型，当前值:",
              this.form.checkType,
              "可用选项:",
              this.checkTypeOptions
            );
            // 如果找不到匹配，尝试直接匹配typeCode
            const directMatch = this.checkTypeOptions.find(
              (option) => option.value === this.form.checkType
            );
            if (directMatch) {
            } else {
              console.warn("直接匹配也失败，保持原值:", this.form.checkType);
            }
          }
        } else {
          // 如果不是数字，尝试直接匹配typeCode
          const directMatch = this.checkTypeOptions.find(
            (option) => option.value === this.form.checkType
          );
          if (directMatch) {
          } else {
            console.warn("直接匹配失败，当前值:", this.form.checkType);
          }
        }
      }
    },

    // 检查类型变化处理（动态获取检查表）
    async handleCheckTypeChange (value) {
      // 清空已选检查表，仅新增时清空
      if (this.pageMode !== "edit") {
        this.form.checkListId = null;
        this.form.checkListName = "";
      }
      // 未选择检查类型，清空选项
      if (!value && value !== 0) {
        this.formOptions = [];
        return;
      }
      try {
        this.formOptionsLoading = true;
        const res = await getCheckListByType(value);
        const list = (res && res.data && (res.data.data || res.data)) || [];
        this.formOptions = Array.isArray(list)
          ? list.map((item) => ({
            label: item.checkListName,
            value: String(item.checkListId || item.id),
          }))
          : [];

        // 关键：编辑时确保当前已选检查表能被展示名称
        if (
          this.pageMode === "edit" &&
          this.form.checkListId &&
          !this.formOptions.some(
            (o) => String(o.value) === String(this.form.checkListId)
          )
        ) {
          this.formOptions.unshift({
            label: this.form.checkListName || String(this.form.checkListId),
            value: String(this.form.checkListId),
          });
        }
      } catch (e) {
        console.error("获取检查表失败:", e);
        this.formOptions = [];
      } finally {
        this.formOptionsLoading = false;
      }
    },

    // 开始日期变化处理
    handleStartDateChange (value) {
      // 如果开始日期被清空，同时清空结束日期
      if (!value) {
        this.form.planEndDate = "";
      }
    },

    // 计划周期变化处理
    handlePlanCycleChange (value) {
      if (value === 0) {
        // 一次性计划时，清空频率相关字段，但不清空结束日期
        this.form.checkFrequency = null;
        this.form.executionDetail = [];
      }
    },

    // 执行频率变化处理
    handleCheckFrequencyChange (value) {
      this.form.executionDetail = [];
      this.form.executionDetail = value === 0 ? "" : [];
      // 根据频率设置详情选项
      const frequencyDetailMap = {
        0: [{ label: "每日", value: "daily" }], // 每日（单选）
        1: [
          // 每周（多选）
          { label: "周一", value: "1" },
          { label: "周二", value: "2" },
          { label: "周三", value: "3" },
          { label: "周四", value: "4" },
          { label: "周五", value: "5" },
          { label: "周六", value: "6" },
          { label: "周日", value: "7" },
        ],
        2: Array.from({ length: 31 }, (_, i) => ({
          label: `${i + 1}日`,
          value: String(i + 1),
        })), // 每月（多选 1-31）
      };

      this.frequencyDetailOptions = frequencyDetailMap[value] || [];
      this.$nextTick(() => {
        this.$refs.checkPlanForm &&
          this.$refs.checkPlanForm.validateField("executionDetail");
      });
    },

    // 负责人选择处理
    handlePersonSelection (selection) {
      this.selectedPersons = selection;
    },

    // 确认负责人选择
    confirmPersonSelection () {
      if (this.selectedPersons.length > 0) {
        this.form.responsiblePersonId = this.selectedPersons.map(
          (person) => person.id
        );
        this.form.responsiblePersonName = this.selectedPersons
          .map((person) => person.name)
          .join(",");
      } else {
        this.form.responsiblePersonId = [];
        this.form.responsiblePersonName = "";
      }
      this.showPersonDialog = false;
    },

    // 根据部门ID查找完整路径
    findDeptPathById (nodes, targetId, currentPath = []) {
      // 确保targetId是字符串类型，便于比较
      const targetIdStr = String(targetId);

      for (const node of nodes) {
        const newPath = [...currentPath, node.id];
        // 统一转换为字符串进行比较
        if (String(node.id) === targetIdStr) {
          return newPath;
        }
        if (node.children && node.children.length > 0) {
          const found = this.findDeptPathById(node.children, targetId, newPath);
          if (found) return found;
        }
      }
      return null;
    },

    // 部门变化处理
    normalizeDeptIds (rowData) {
      if (
        rowData &&
        Array.isArray(rowData.responsibleDeptList) &&
        rowData.responsibleDeptList.length > 0
      ) {
        return rowData.responsibleDeptList
          .map((item) => item.responsibleDeptId || item.deptId || item.id)
          .filter((id) => id !== undefined && id !== null && id !== "")
          .map((id) => String(id));
      }
      if (rowData && rowData.responsibleDeptId) {
        return String(rowData.responsibleDeptId)
          .split(",")
          .map((id) => id.trim())
          .filter(Boolean);
      }
      return [];
    },

    handleDepartmentChange (value) {
      const deptIds = Array.isArray(value) ? value.map((id) => String(id)) : (value ? [String(value)] : []);
      if (deptIds.length > 0) {
        const deptNames = this.departmentTreeData
          .filter((item) => deptIds.includes(String(item.value)))
          .map((item) => item.label);
        this.form.responsibleDeptName = deptNames.join(",");
      } else {
        this.form.responsibleDeptName = "";
      }
    },

    // 负责人变化处理
    handlePersonChange (value) {
      // 处理多选负责人
      if (Array.isArray(value) && value.length > 0) {
        const selectedPersons = this.personTableData.filter((person) =>
          value.includes(person.id)
        );
        this.form.responsiblePersonName = selectedPersons
          .map((person) => person.name)
          .join(",");
      } else {
        this.form.responsiblePersonName = "";
      }
    },
    // 验收人员变化处理
    handleAcceptPersonChange (value) {
    },

    // 检查表变化处理
    handleCheckListChange (value) {
      const selectedForm = this.formOptions.find(
        (form) => String(form.value) === String(value)
      );
      if (selectedForm) {
        this.form.checkListName = selectedForm.label;
      } else {
        // 兜底：若未在选项中，保持ID但清空名称，避免显示纯ID
        this.form.checkListName = "";
      }
    },

    // 区域选择处理
    handleAreaCheck (data, checked) { },

    // 确认区域选择
    confirmAreaSelection () {
      this.showAreaDialog = false;
      // 这里可以处理选中的区域
    },

    // 预览检查项（从接口获取）
    async previewInspectionItems () {
      const checkListId = this.form.checkListId;
      console.error("获取检查项预览", checkListId);
      if (!checkListId) {
        this.$message.warning("请先选择检查表");
        return;
      }
      try {
        const res = await getCheckListPreview(checkListId);
        const rows = (res && res.data && (res.data.data || res.data)) || [];
        // 兼容字段名：category/item/standard/method 若后端字段不同可在此适配
        this.previewData = rows.map((item) => ({
          // category: item.category || item.typeName || item.groupName || "",
          itemName: item.itemName || "",
          checkListStandard: item.checkListStandard || "",
          isRequired: item.isRequired === 0 ? "否" : "是" || "",
        }));
        this.showPreviewDialog = true;
      } catch (e) {
        console.error("获取检查项预览失败:", e);
        this.$message.error("获取检查项预览失败");
      }
    },

    // 重置表单
    handleReset () {
      this.$refs.checkPlanForm.resetFields();
      this.form = {
        planName: "",
        checkType: null,
        responsibleDeptId: [],
        responsibleDeptName: "",
        responsiblePersonId: [],
        acceptPerson: [],
        responsiblePersonName: "",
        checkFrequency: null,
        planCycle: null,
        executionDetail: [],
        planStartDate: "",
        planEndDate: "",
        checkListId: null,
        checkListName: "",
        remark: "",
        list: [],
      };
    },

    // 提交表单
    async handleSubmit () {
      try {
        await this.$refs.checkPlanForm.validate();
        this.submitting = true;

        // 构建提交数据 - 根据实体类字段调整
        const areaList = (this.form.list || []).map((areaId) => {
          const opt =
            (this.areaOptions || []).find((o) => o.value === areaId) || {};
          return { areaName: opt.label || String(areaId), areaId };
        });
        // 提取areaName和areaId，用逗号分隔
        const typeName = areaList.map((item) => item.areaName).join(",");
        const typeCode = areaList.map((item) => item.areaId).join(",");

        const submitData = {
          ...this.form,
          // 添加typeName和typeCode字段
          areaName: typeName,
          areaCode: typeCode,
          // 处理责任部门ID - 确保提交单个ID而不是数组
          responsibleDeptId: Array.isArray(this.form.responsibleDeptId)
            ? this.form.responsibleDeptId.join(",")
            : this.form.responsibleDeptId,
          // 处理多选负责人数据
          responsiblePersonId: Array.isArray(this.form.responsiblePersonId)
            ? this.form.responsiblePersonId.join(",")
            : this.form.responsiblePersonId,
          acceptPerson:  Array.isArray(this.form.acceptPerson)
            ? this.form.acceptPerson.join(",")
            : this.form.acceptPerson,
          // 处理执行频率详情，按逗号分隔
          executionDetail: Array.isArray(this.form.executionDetail)
            ? this.form.executionDetail.join(",")
            : this.form.executionDetail,
        };

        // 编辑模式下添加ID
        if (this.pageMode === "edit" && this.editId) {
          submitData.id = this.editId;
        }

        // 根据模式调用不同的API
        let response;
        if (this.pageMode === "edit") {
          response = await updateCheckPlan(submitData);
        } else {
          response = await addCheckPlan(submitData);
        }

        if (response && (response.code === 200 || response.success !== false)) {
          this.$message.success(
            this.pageMode === "edit" ? "检查计划修改成功" : "检查计划创建成功"
          );
          this.$router.go(-1);
          // this.$router.push(
          //   "/dispatched-personnel-track/check-inspection-plan-list/index"
          // );
        } else {
          this.$message.error(
            response.message ||
            (this.pageMode === "edit" ? "修改失败" : "创建失败")
          );
        }
      } catch (error) {
        console.error(
          this.pageMode === "edit" ? "修改失败:" : "创建失败:",
          error
        );
        this.$message.error(
          (this.pageMode === "edit" ? "修改失败: " : "创建失败: ") +
          (error.message || "网络错误")
        );
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.create-check-plan {
  padding: 12px;
  background-color: #f5f7fa;
  min-height: 100vh;
  padding-bottom: 100px; /* 增加底部内边距，避免被导航栏遮挡 */

  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .header-left {
      .back-btn {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
        padding: 0;

        &:hover {
          color: #409eff;
        }
      }
    }

    .header-right {
      .el-breadcrumb {
        font-size: 14px;
        color: #909399;
      }
    }
  }

  .form-container {
    .form-card {
      background: white;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      margin-bottom: 10px;
      overflow: hidden;

      .card-header {
        background: #f8f9fa;
        padding: 8px 12px;
        border-bottom: 1px solid #ebeef5;

        .card-title {
          font-size: 16px;
          font-weight: 600;
          color: #303133;
        }
      }

      .card-content {
        padding: 12px;
      }

      // 分区样式
      .section-divider {
        height: 1px;
        background: #ebeef5;
        margin: 20px 0;
      }

      .section-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 16px;
        padding-left: 8px;
        border-left: 4px solid #409eff;
      }
    }

    .form-actions {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      margin-top: 12px;
      padding: 10px 0 10px 0; /* 增加底部内边距 */
      position: relative;
      z-index: 10; /* 确保按钮在最上层 */
    }
  }

  .department-tree,
  .area-selection {
    max-height: 300px;
    overflow-y: auto;
  }

  .person-selection {
    .el-table {
      border: 1px solid #ebeef5;
    }
  }

  .inspection-preview {
    .el-table {
      border: 1px solid #ebeef5;
    }
  }
}

// 表单样式优化
::v-deep .el-form-item__label {
  font-weight: 500;
  color: #606266;
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  border-radius: 4px;
  border: 1px solid #dcdfe6;

  &:focus {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }
}

::v-deep .el-select {
  width: 100%;
}

::v-deep .el-radio-group {
  .el-radio {
    margin-right: 30px;
  }
}

::v-deep .el-date-editor {
  width: 100%;
}

// 必填字段标识
::v-deep .el-form-item.is-required .el-form-item__label::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

// 确保页面有足够的滚动空间
body {
  overflow-x: hidden;
  overflow-y: auto;
}

// 确保按钮区域不被遮挡
.form-actions {
  margin-bottom: 10px !important; /* 强制底部间距 */
}

// 预览弹窗样式修复
::v-deep .el-dialog__wrapper {
  z-index: 3000 !important;
}

::v-deep .el-dialog {
  z-index: 3001 !important;
}

::v-deep .el-dialog__header {
  z-index: 3002 !important;
}

::v-deep .el-dialog__body {
  z-index: 3002 !important;
}

::v-deep .el-dialog__footer {
  z-index: 3002 !important;
}

// 表单样式优化
::v-deep .el-form-item__label {
  font-weight: 500;
  color: #606266;
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  border-radius: 4px;
}

::v-deep .el-select {
  width: 100%;
}

::v-deep .el-radio-group {
  .el-radio {
    margin-right: 30px;
  }
}

// 对话框样式
::v-deep .el-dialog {
  border-radius: 8px;
}

::v-deep .el-dialog__header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #ebeef5;
  border-radius: 8px 8px 0 0;
}

::v-deep .el-dialog__body {
  padding: 20px;
}

::v-deep .el-dialog__footer {
  background-color: #f8f9fa;
  border-top: 1px solid #ebeef5;
  border-radius: 0 0 8px 8px;
}
</style>
